import { Subject, BehaviorSubject } from "rxjs";
const themeSubject = new Subject();
const configSubject = new BehaviorSubject({
  theme: "f-dark",
  iconPack: null
});
const ConfigUtil = {
  getConfig() {
    return configSubject.value;
  },
  setConfig(cfg) {
    configSubject.next({ ...configSubject.value, ...cfg });
    if (cfg.theme) {
      this.initTheme();
    }
  },
  initTheme() {
    document.documentElement.setAttribute("data-theme", `${configSubject.value.theme}`);
  }
};
const cssSet = /* @__PURE__ */ new Set();
function injectCss(id, css) {
  if (cssSet.has(id) || !document) {
    return;
  }
  cssSet.add(id);
  const style = document.createElement("style");
  style.id = id;
  style.innerHTML = css;
  document.head.appendChild(style);
}
export {
  ConfigUtil,
  configSubject,
  injectCss,
  themeSubject
};
//# sourceMappingURL=index.es.js.map
